import _ from 'lodash';
import {Action} from 'ducks/types';

export const OPEN_MODAL = 'modals/OPEN_MODAL';
export const CLOSE_MODAL = 'modals/CLOSE_MODAL';
export const REMOVE_MODAL_DATA_FROM_STORE =
  'modals/REMOVE_MODAL_DATA_FROM_STORE';
const STORE_DATA_IN_MODAL = 'modals/STORE_DATA_IN_MODAL';
export const CLOSE_ALL_MODALS = 'modals/CLOSE_ALL_MODALS';

export const openModal = (modalName, data?: any, url = false) => ({
  type: OPEN_MODAL,
  payload: {
    modalName,
    data,
    url
  }
});

export const closeModal = modalName => ({
  type: CLOSE_MODAL,
  payload: {
    modalName
  }
});

export const removeModalDataFromStore = modalName => ({
  type: REMOVE_MODAL_DATA_FROM_STORE,
  payload: {
    modalName
  }
});

export const storeDataInModal: Action = ({modalName, data}) => ({
  type: STORE_DATA_IN_MODAL,
  payload: {
    modalName,
    data
  }
});

export const closeAllModals: Action = () => ({
  type: CLOSE_ALL_MODALS,
  payload: {}
});

export const openNoPermissionModal = ({disableClose, noPermissionMessage}) =>
  openModal(MODALS.NO_PERMISSION, {disableClose, noPermissionMessage});

export const openInformationModal = ({message, heading}) =>
  openModal(MODALS.INFORMATION_MODAL, {message, heading});

export const openCsvExportModal = ({
  heading,
  message,
  errors,
  processing
}: any) =>
  openModal(MODALS.CSV_EXPORT_MODAL, {heading, message, errors, processing});

export const openXlsxExportModal = ({
  heading,
  message,
  errors,
  processing,
  downloadUrl
}: any) =>
  openModal(MODALS.XLSX_EXPORT_MODAL, {
    heading,
    message,
    errors,
    processing,
    downloadUrl
  });

export const selectModal = (state, modalName) =>
  _.get(state, `modal.${modalName}`, {});

export const isModalOpen = (state, modalName) =>
  _.get(state, `modal.${modalName}.isOpen`, false);

const initialState = {};

const reducer = (state = initialState, action) => {
  const modalName = _.get(action, 'payload.modalName');

  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        [modalName]: {
          isOpen: true,
          data: action.payload.data || {}
        }
      };

    case REMOVE_MODAL_DATA_FROM_STORE:
      return {
        ...state,
        [modalName]: {
          isOpen: false,
          data: {}
        }
      };
    case STORE_DATA_IN_MODAL:
      return {
        ...state,
        [modalName]: {
          ...state[modalName],
          data: {
            ...state[modalName].data,
            ...action.payload.data
          }
        }
      };
    default:
      return state;
  }
};

export const MODALS = {
  CONFIRM: 'confirm',
  NO_PERMISSION: 'noPermission',
  INFORMATION_MODAL: 'information',
  CSV_EXPORT_MODAL: 'csvExport',
  XLSX_EXPORT_MODAL: 'xlsxExport',
  AGREEMENT_USER_TAKE_PHOTO: 'agreementUserTakePhoto',
  CREATE_BOOKING: 'createBooking',
  BOOKING_NOTES: 'bookingNotes',
  ROOM_NOTES: 'roomNotes',
  SALES_NOTES: 'salesNotes',
  MEMBER_CHECK_OUT: 'memberCheckOut',
  ONE_OFF_CHARGE: 'oneOffCharge'
};

export default reducer;

export {default as modalsSaga} from './saga';
